import React, { Component, Fragment } from 'react'
import AudioComponent from '../AudioComponent'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import { Link, withRouter } from 'react-router-dom'
import TextDescription from '../TextDescription'
import VoiceItem from '../VoiceItem'
import Favourite from '../Favourite'
import Loader from '../Loader'
import ServicesCard from '../ServicesCard'
import './index.sass'
import { getLanguagesFromVoices } from '../../helpers/voice.helper'
import { resolutions } from '../../utils/constants'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const additionalServices = [
  { serviceTab: 'video-localization', value: 'translating' },
  { serviceTab: 'video-localization', value: 'proofreading' },
  { serviceTab: 'video-localization', value: 'advertising' },
  { serviceTab: 'video-localization', value: 'cutting' },
  { serviceTab: 'video-localization', value: 'dubbing' },
  { serviceTab: 'video-localization', value: 'subtitling' },
]

const voiceOverAdditionalServices = [
  { serviceTab: 'voice-over', value: 'gaming' },
  { serviceTab: 'voice-over', value: 'mobile-apps' },
  { serviceTab: 'voice-over', value: 'radio-spots' },
]

class VoiceDetails extends Component {
  state = {
    lang: this.props.match.params.lang,
    langForTranslate: this.props.match.params.lang.split('-')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' '),
    width: window.innerWidth,
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentDidMount = () => {
    const {
      voices,
      voiceDescriptions,
      actions: { getVoicesDescr, getVoicesList },
    } = this.props
    if (voices.length === 0 || Object.keys(voiceDescriptions).length === 0) {
      getVoicesDescr()
    }
    window.addEventListener('resize', this.updateDimensions)
    getVoicesList()
  }

  

  componentDidUpdate = (prevProps) => {
    const { lang } = this.state
    const {
      actions: { setPlayList },
      match,
    } = this.props
    const voices = this.getVoicesByLang(lang)
    if (voices.length > 0) {
      setPlayList(voices)
    }
    if (prevProps.match.url !== match.url) {
      document.getElementById('voice-details').scrollTo(0, 0)
    }
  }

  getDescriptionsByLang = lang => {
    const { voiceDescriptions, t } = this.props
    const langForFindTranslations = lang.toLowerCase().split(' ').join('-')
    const descriptions = voiceDescriptions[langForFindTranslations] && [
      t(`voiceDetail.${langForFindTranslations}.mainDescription`, { returnObjects: true }),
      t(`voiceDetail.${langForFindTranslations}.additionalDescription`, { returnObjects: true }),
    ]
    return descriptions
  }

  getExtendedDescriptionsByLang = lang => {
    const { voiceDescriptions, t } = this.props
    const langForFindTranslations = lang.toLowerCase().split(' ').join('-')
    const extendedDescriptions = voiceDescriptions[langForFindTranslations] && [
      t(`voiceDetail.${langForFindTranslations}.extendedDescription`, { returnObjects: true }),
    ]
    return extendedDescriptions
  }

  getVoicesByLang = () => {
    const { voices } = this.props
    const { langForTranslate } = this.state
    return voices.filter(voice => voice.language && voice.language === langForTranslate)
  }

  handleBack = () => {
    const { lng, history } = this.props
    const path = lng === 'en' ? '/voices' : `/${lng}/voices`
    history.push(path)
  }

  getVoiceForRuAndDe = (fullArray, excludedArray) => {
    const filtered = fullArray.reduce( (acc, item) => {
      if (!excludedArray.includes(item)) acc.push(item)
    return acc} , [])
    return filtered
  }

  onAnotherLanguageClick = (lang) => {
    this.setState({
      lang: lang,
      langForTranslate: lang.split('-')
      .map(s => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ')})
  }

  render = () => {
    const { lang, langForTranslate } = this.state
    const {
      loading,
      actions: {
        toggleFavoriteVoice,
        changeModalVisibility,
        toggleVisibleAudioPlayer,
        setPlayingStatus,
        setPlayingVoiceId,
        setChoosenVoice,
      },
      voices,
      t,
      lng,
      isAudioVisible,
      currentVoiceId,
      isAudioPlaying,
      // voiceDescriptions,
    } = this.props

    const { width } = this.state

    const path = lng === 'en' ? '' : `/${lng}`

    const descriptions = this.getDescriptionsByLang(langForTranslate)
    const extendedDescriptions = this.getExtendedDescriptionsByLang(langForTranslate)
    const audioVoices = this.getVoicesByLang(langForTranslate)

    const additionalVoicesLinks = getLanguagesFromVoices(voices)
    //  lng !== 'ru' ? : this.getVoiceForRuAndDe(getLanguagesFromVoices(voices), EXCLUDED_DE_VOICES)

    const maleVoices = audioVoices.filter(elem => elem.gender.toLowerCase() === 'male')
    const femaleVoices = audioVoices.filter(elem => elem.gender.toLowerCase() === 'female')
    // const subTitle = voiceDescriptions[lang] && voiceDescriptions[lang].subTitle
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{lng !== 'ru' ? t('meta.voiceDescr.title', { lang: t(`Language.${langForTranslate}`) }) : t('meta.voiceDescr.title', { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) }) }</title>
          <link rel="alternate" hrefLang="en"
              href={`https://unimedia.io/voices/${lang}`} />
          <link rel="alternate" hrefLang="de"
              href={`https://unimedia.io/de/voices/${lang}`} />
          <link rel="alternate" hrefLang="ru"
              href={`https://unimedia.io/ru/voices/${lang}`} />
          <link rel="alternate" hrefLang="x-default"
              href={`https://unimedia.io/voices/${lang}`} />
          <meta
            name="description"
            content={lng !== 'ru' ? t('meta.voiceDescr.descr', { lang: t(`Language.${langForTranslate}`) }) : t('meta.voiceDescr.descr', { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) })}
          />
          {lng !== 'ru' && <meta name="keywords" content={t(`voiceDetail.${lang}.keywords`, { lang: t(`Language.${langForTranslate}`) })} />}
          {lng === 'en' ? <link rel="canonical" href={`https://unimedia.io/voices/${lang}`} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/voices/${lang}`} />}
          <meta property="og:title" content={lng !== 'ru' ? t('meta.voiceDescr.title', { lang: t(`Language.${langForTranslate}`) }) : t('meta.voiceDescr.title', { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) }) } />
          <meta property="og:description" content={lng !== 'ru' ? t('meta.voiceDescr.descr', { lang: t(`Language.${langForTranslate}`) }) : t('meta.voiceDescr.descr', { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) })} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? `https://unimedia.io/voices/${lang}`: `https://unimedia.io/${lng}/voices/${lang}`} />

          <script type="application/ld+json">
            {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${lng === 'en'
              ? `${t(`Language.${langForTranslate}`)} voice over`
              : lng === 'de' ?
              `${t(`Language.${langForTranslate}`)} Sprecher` :
              t(`voiceDetail.${lang}.title`, { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) }) }",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t(`voiceDetail.${lang}.subTitle`, { lang: lng !== 'ru' ? t(`Language.${langForTranslate}`) : t(`PrepositionalCaseLanguage.${langForTranslate}`) }) }",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Universal Media",
              "alternateName": "Unimedia",
              "url": "https://unimedia.io",
              "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.voices')}",
                "item": "https://unimedia.io/voices"
              },{
                "@type": "ListItem",
                "position": 3,
                "name": "${langForTranslate}"
              }]
            }
            ]`}
          </script>
          
        </Helmet>
        <ScrollUpButton id={'voice-details'} />
        <div className="voice-details-page container overflow-y" id='voice-details'>
          <div className="container-wrapper">
            {/* <button onClick={this.handleBack} className="btn btn-back subtitle-2">
              {t('general.back')}
            </button> */}
            
            <Breadcrumbs pathname={window.location.pathname}/>
            <h1 className="main-title">
              {lng === 'en'
                ? `${t(`Language.${langForTranslate}`)} voice over`
                : lng === 'de' ?
                 `${t(`Language.${langForTranslate}`)} Sprecher` :
                 t('voiceDetail.title', { lang: t(`PrepositionalCaseLanguage.${langForTranslate}`) }) }
            </h1>
            <h2 className="titles_main-title">{t('voiceDetail.subTitle', { lang: lng !== 'ru' ? t(`Language.${langForTranslate}`) : t(`PrepositionalCaseLanguage.${langForTranslate}`) }) }</h2>
            <div className="voices-controls">
              <Favourite toggleFavoriteVoice={toggleFavoriteVoice} />
            </div>
            {loading ? (
              <Loader />
            ) : (
              <Fragment>
                <div className="description">
                  {descriptions &&
                    descriptions.map((elem, index) => (
                      <TextDescription arrText={elem} key={`${index}-${lang}`} />
                    ))}
                    {lng !== 'ru' &&
                    width>=resolutions.tablet &&
                    extendedDescriptions &&
                    extendedDescriptions[0].length>0 &&
                    extendedDescriptions.map((elem, index) => (
                      <TextDescription arrText={elem} key={`${index+2}-${lang}`} />
                    ))}
                  <span className="body-bold">
                    <TextDescription arrText={[t('general.voiceDetails')]} />
                  </span>
                  {width>=resolutions.tablet &&
                    <div className="voiceDetail-voiceLinksBlock">
                      <h5 className='voiceDetail-allLanguagesTitle'>
                        {t('home.foreigns.allLanguages.subtitle')}:
                      </h5>
                        { additionalVoicesLinks.map(voice=> {
                          return (
                            <div key={voice}>
                              <Link
                              to={`${path}/voices/${voice.toLowerCase().split(' ').join('-')}`}
                              onClick={()=>this.onAnotherLanguageClick(voice)}
                              >
                                {t(`Language.${voice}`)}
                              </Link>
                            </div>
                          )
                        })}
                    </div>
                  }
                  
                </div>
                
                <div className="voices-list-wrapper">
                  <div className="voices-list">
                    <p className="subtitle-1">{t('filter.Male')}</p>
                    {maleVoices.map(voice => (
                      <VoiceItem
                        key={voice.id}
                        voiceItem={voice}
                        toggleFavoriteVoice={toggleFavoriteVoice}
                        changeModalVisibility={changeModalVisibility}
                        toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                        setPlayingStatus={setPlayingStatus}
                        currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
                        setPlayingVoiceId={setPlayingVoiceId}
                        setChoosenVoice={setChoosenVoice}
                      />
                    ))}
                  </div>
                  <div className="voices-list">
                    <p className="subtitle-1">{t('filter.Female')}</p>
                    {femaleVoices.map(voice => (
                      <VoiceItem
                        key={voice.id}
                        voiceItem={voice}
                        toggleFavoriteVoice={toggleFavoriteVoice}
                        changeModalVisibility={changeModalVisibility}
                        toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                        setPlayingStatus={setPlayingStatus}
                        currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
                        setPlayingVoiceId={setPlayingVoiceId}
                        setChoosenVoice={setChoosenVoice}
                      />
                    ))}
                  </div>
                  {lng !== 'ru' && width<resolutions.tablet && extendedDescriptions &&
                  extendedDescriptions.map((elem, index) => (
                      <TextDescription arrText={elem} key={`${index+2}-${lang}`} />
                    ))}
                  <div className={'additional-services-container'}>
                    <div>
                      <h4 className="subtitle-1">{t('services.voiceOverServices')}</h4>
                      <div className="additional-services">
                        {voiceOverAdditionalServices.map((card, index) => (
                          <ServicesCard
                            key={index}
                            value={card.value}
                            label={card.value}
                            serviceTab={card.serviceTab}
                          />
                        ))}
                      </div>
                      <Link className="simple-links" to={`${path}/services/voice-over`}>
                        {t('services.allVoiceOverServices')}
                        <img src='/assets/arrow60px-cyan.svg' className="arrows" />
                      </Link>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                      <h4 className="subtitle-1">{t('services.videoLocalizationServices')}</h4>
                      <div className="additional-services">
                        {additionalServices.map((card, index) => (
                          <ServicesCard
                            key={index}
                            value={card.value}
                            label={card.value}
                            serviceTab={card.serviceTab}
                          />
                        ))}
                      </div>
                      <Link className="simple-links" to={`${path}/services/video-localization`}>
                        {t('services.allVideoLocalizationServices')}
                        <img src='/assets/arrow60px-cyan.svg' className="arrows" />
                      </Link>
                    </div>
                  </div>
                  {width<resolutions.tablet &&
                    <div className="voiceDetail-voiceLinksBlock">
                      <h5 className='voiceDetail-allLanguagesTitle'>
                        {t('home.foreigns.allLanguages.subtitle')}:
                      </h5>
                        { additionalVoicesLinks.map(voice=> {
                          return (
                            <div key={voice}>
                              <Link
                              to={`${path}/voices/${voice.toLowerCase().split(' ').join('-')}`}
                              onClick={()=>this.onAnotherLanguageClick(voice)}
                              >
                                {t(`Language.${voice}`)}
                              </Link>
                            </div>
                          )
                        })}
                    </div>
                  }
                </div>
                {isAudioVisible && <AudioComponent />}
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.app.loading,
  voiceDescriptions: state.voiceDescriptions,
  voices: state.voices,
  isAudioVisible: state.audioPlayer.isVisible,
  currentVoiceId: state.audioPlayer.currentVoiceId,
  isAudioPlaying: state.audioPlayer.isPlaying,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(VoiceDetails))
)
